import React from "react";
import './modal.css';

export const PopUp = ({ handleClose, show, children }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  return (
       <div className={showHideClassName}>
       {/* <div className="modal display-block"> */}
        <section className="modal-main">
          {children}
          <div className="row justify-content-md-center" styles={{height:"40px"}}>
          <p> </p>
          </div>
          <div className="row justify-content-md-center">
            <input type="button" className="btn btn-primary" value="Chiudi" onClick={handleClose} style={{alignItems:'center'}}></input>
          </div>
        </section>
      </div>
  );
};




// import React, { Component } from "react";

// export class PopUp extends Component {
//   constructor() {
//     super();
//     this.state = {
//       show: false
//     };
//     this.showModal = this.showModal.bind(this);
//     this.hideModal = this.hideModal.bind(this);
//   }

//   showModal = () => {
//     this.setState({ show: true });
//   };

//   hideModal = () => {
//     this.setState({ show: false });
//   };

//   // handleClick = () => {
//   //   this.props.toggle();
//   // };

//   render() {
//     return (
//       <div className="modal">
//         <div className="modal_content">
//           <span className="close" onClick={this.handleClick}>
//             {/* &times; */}
//           </span>
//           <p>Popup!</p>
//           <h1>{this.props.text}</h1>
//         <button onClick={this.props.closePopup}>close me</button>
//         </div>
//       </div>
//     );
//   }
// }

